'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var TextEntry = require('@arrive/text-entry');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var TextEntry__default = /*#__PURE__*/_interopDefaultLegacy(TextEntry);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded = ["value", "setTime", "onKeyUp", "onBlur", "customValidation", "isRequired", "isDisabled", "classes", "label", "errorText"];
var validValueLength = 5;
var isValidTimeRegex = /^([0-9]|0[0-9]|1[0-9]|2[0-3])((:([0-9]|[0-5][0-9]))?)$/; // Is good for checking the final value

var isValidInputRangeRegex = /^([0-9]|0[0-9]|1[0-9]|2[0-5])(([0-9])?(:)?(:([0-9]|[0-5][0-9]))?)$/;
var isValidKeypressRegex = /[^:0-9/]/;

var replaceMinutesIfGreaterThanFifty = function replaceMinutesIfGreaterThanFifty(minutes) {
  if (minutes && minutes.length === 2) {
    if (Number(minutes[0]) > 5) {
      return "5".concat(minutes.slice(1));
    }
  }

  return minutes;
};

function TimeEntry(_ref) {
  var value = _ref.value,
      setTime = _ref.setTime,
      onKeyUp = _ref.onKeyUp,
      onBlur = _ref.onBlur,
      customIsValid = _ref.customValidation,
      isRequired = _ref.isRequired,
      isDisabled = _ref.isDisabled,
      classes = _ref.classes,
      label = _ref.label,
      errorText = _ref.errorText,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasError = _useState2[0],
      setHasError = _useState2[1];

  React.useEffect(function () {
    if (hasError && (value === null || value === void 0 ? void 0 : value.length) === validValueLength && isValidTimeRegex.test(value)) {
      setHasError(false);
    }
  }, [hasError, value]);

  var handleChange = function handleChange(evt) {
    var nextValue = evt.target.value;

    if (!nextValue.length || isValidInputRangeRegex.test(nextValue)) {
      setTime(nextValue);

      if (nextValue.length === 5 && isValidTimeRegex.test(nextValue)) {
        setHasError(false);
      }
    }
  };

  var validateFullInput = function validateFullInput() {
    if (customIsValid) {
      setHasError(!customIsValid(value));
    } else {
      // CAREX-1724: Opportunistically format 3 digit inputs to 0X:XX format on Blur
      if ((value === null || value === void 0 ? void 0 : value.length) === 4 && value.includes(':')) {
        var cleanedString = String(value).replace(/:/g, '');
        setTime("0".concat(cleanedString.slice(0, 1), ":").concat(replaceMinutesIfGreaterThanFifty(cleanedString.slice(1))));
        setHasError(false);
      } else if (value.length !== 5 && !!value.length || !isValidTimeRegex.test(value)) {
        setHasError(true);
      } else {
        setHasError(false);
      }
    }
  };

  var defaultOnKeyUp = function defaultOnKeyUp(evt) {
    var pressedKey = evt.key;
    var currentTime = value;
    var newTime = '';

    if (pressedKey !== 'Backspace' && !isValidKeypressRegex.test(pressedKey)) {
      var number = !isNaN(parseInt(pressedKey, 10)) ? parseInt(pressedKey, 10) : '';

      if (currentTime.length === 1 && number > 2 || currentTime.length === 2 && pressedKey === ':') {
        newTime = "0".concat(currentTime);
      }

      if (currentTime.length > 2 && currentTime[2] !== ':') {
        newTime = "".concat(currentTime.slice(0, 2), ":").concat(currentTime.slice(2));
      }

      if (currentTime.length === 3 && pressedKey !== ':') {
        newTime = "".concat(currentTime.slice(0, 2), ":").concat(number);
      }

      if (currentTime.length === 4) {
        newTime = "".concat(currentTime.slice(0, 2), ":").concat(number);
      }
    } else {
      newTime = currentTime;
    }

    if (!newTime) {
      return;
    }

    if (!isValidTimeRegex.test(newTime)) {
      setHasError(true);
    } else {
      setHasError(false);
    }

    setTime(newTime);
  };

  return /*#__PURE__*/React__default["default"].createElement(TextEntry__default["default"], _extends({
    value: value,
    onChange: handleChange,
    onKeyUp: onKeyUp ? onKeyUp : defaultOnKeyUp,
    label: label,
    classes: classes ? classes : null,
    required: isRequired,
    disabled: isDisabled,
    onBlur: onBlur ? onBlur : validateFullInput,
    errorText: hasError && (errorText ? errorText : 'Enter a valid time')
  }, rest));
}
TimeEntry.displayName = "TimeEntry";
TimeEntry.propTypes = {
  value: PropTypes__default["default"].string.isRequired,
  setTime: PropTypes__default["default"].func.isRequired,

  /* Optional override to string parsing logic */
  onKeyUp: PropTypes__default["default"].func,

  /* Optional override for validation and onBlur actions */
  onBlur: PropTypes__default["default"].func,

  /* Optional custom validator. Should accept the current value and return t/f if valid */
  customValidation: PropTypes__default["default"].func,
  isRequired: PropTypes__default["default"].bool,
  isDisabled: PropTypes__default["default"].bool,

  /* Override for the TextEntry inputWrapper */
  classes: PropTypes__default["default"].shape({
    /** The container containing the label and the input */
    container: PropTypes__default["default"].string,

    /** The wrapper around the input - mostly responsible for sizing */
    inputWrapper: PropTypes__default["default"].string,

    /** The input element itself */
    input: PropTypes__default["default"].string,

    /** The contained label */
    label: PropTypes__default["default"].string
  }),
  label: PropTypes__default["default"].string.isRequired,
  errorText: PropTypes__default["default"].string
};

module.exports = TimeEntry;
